<template>
    <SOSlotBase :bg-white="true" :loading="pageSetting.loading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar page-title="Masa Aktif Cashback E-Payment" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-y-12">
                <div class="f-regular f-14 f-c-primary">
                    Pengaturan Masa aktif untuk E-Payment yang didapatkan dari cashback kupon & voucher pelanggan
                </div>
            </div>
            <div class="separator"></div>
            <div id="form_container" class="d-flex-column justify-content-between min p-x-20 p-y-20">
                <div >
                    <SOInputNominal
                        title="Masa Aktif Cashback Promo"
                        :required="true"
                        :prefix-right="true"
                        placeholder="30"
                        prefix="Hari"
                        :defaultValue="inputNominal.cashback_active_period.formatted"
                        v-model="inputNominal.cashback_active_period"
                        @input="r => handleNominalChange(r)"
                    />
                    <ErrorMessage 
                        class="error" 
                        label="Masa Aktif Cashback Promo"
                        :validation="$v.cashback_active_period"
                    />
                </div>
                <SOButton
                    text="Simpan"
                    :primary="true"
                    :full="true"
                    :disable="isDisable"
                    :loading="isLoading"
                    @action="onSave()"
                />
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "@/modules/pengaturan-umum/store/state";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOButton from "@/so-components/global/ui/SOButton";
import {minValue, maxValue, required} from "vuelidate/lib/validators";

export default {
    name: "MasaAktifCashback",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOSlotCard,
        SOInputNominal,
        ErrorMessage,
        SOButton,
    },
    computed: {
        ...mapGetters("pengaturanUmumModule", {
            cashbackPeriod: "cashbackActivePeriod",
        }),
        isDisable() {
            return this.isLoading
        }
    },
    data() {
        return {
            inputNominal : {
                cashback_active_period: {
                    raw: null,
                    formatted: null
                },
            },
            cashback_active_period: null,
            pageSetting: {
                loading: false,
                hiddenOptions: false,
                section: {
                    deposit: false,
                    epayment: false,
                    isChekedTake: false
                },
                modal: {
                    konsumen: false,
                    confirm: false,
                    props: {
                        getDataAction: "",
                        submitAction: "",
                        reminderId: "",
                        reminderType: "",
                        reminderAction: "",
                        iddevice: "",
                    },
                },
            },
            isLoading: false,
        };
    },
    validations: {
        cashback_active_period: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(365),
        },
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        ...mapActions(moduleName, {
            getSettingsV2: "getSettingsV2",
            updateActivePeriodCashback: "updateActivePeriodCashback",
        }),
        handleNominalChange(v) {
            this.cashback_active_period = v.raw
        },
        back() {
            this.$router.push({ name: "pengaturanUmum.dashboard" });
        },
        async getInfo() { 
            this.pageSetting.loading = true;
            this.getSettingsV2().then((result) => {
                this.inputNominal.cashback_active_period.formatted = this.cashbackPeriod.toString()
                this.inputNominal.cashback_active_period.raw = this.cashbackPeriod
            }).catch((err) => {
                console.log(err);
            }).finally(() => this.pageSetting.loading = false)

            setTimeout(() => {
                $(".card-body").addClass("card-body-no-footer");
            }, 100);
        },
        errorValidation() {
            this.$v.cashback_active_period.$touch();

            const isValid = this.$v.cashback_active_period.$invalid
            
            return isValid;
        },
        async onSave() {
            if (this.errorValidation()) {
                return;
            }

            this.isLoading = true;
            this.updateActivePeriodCashback(this.cashback_active_period).then((result) => {
                console.log(result);
                if (result.success) {
                    this.$toast.success('Berhasil memperbarui masa aktif cashback')
                    this.$router.back()
                }
                else this.$toast.error(result.err)
            }).catch((err) => {
                this.$toast.error(err)
            }).finally(() => this.isLoading = false)
        }
    },
    beforeDestroy() {
        $(".card-body").removeClass("card-body-no-footer");
    },
};
</script>

<style>
.card-body-no-footer {
    border-bottom: none !important;
    padding-bottom: 0 !important;
}
#form_container {
    min-height: calc(100vh - 177px);
}
</style>
